const MAIN_DOMAIN = 'inseego.com';

let isFirstPage = true;

try {
  // If referrer exists AND hostname matches MAIN_DOMAIN => NOT first page
  if (document.referrer && new URL(document.referrer).hostname === MAIN_DOMAIN) {
    isFirstPage = false;
  }
} catch (e) {
  // If parsing fails => stay true (safe fallback)
}

if (isFirstPage) {
  const campaignDetails = {
    landingPage: window.location.href,
    referrer: document.referrer || '',
    timestamp: new Date().toISOString(),
  };

  // Add to campaign_history
  const campaignHistory = JSON.parse(localStorage.getItem('campaign_history') || '[]');
  campaignHistory.push(campaignDetails);

  // Save to localStorage
  localStorage.setItem('campaign_history', JSON.stringify(campaignHistory));
}
